import api from './api';

export const getSurveyResponseDetails = async surveyResponseId => {
  try {
    const response = await api.get(
      `/reports/getSurveyResponseDetails/${surveyResponseId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los detalles de la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getSurveyResponses = async surveyId => {
  try {
    const response = await api.get(`/reports/getSurveyResponses/${surveyId}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener las encuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getSurveyResponseCount = async surveyId => {
  try {
    const response = await api.get(
      `/reports/getSurveyResponseCount/${surveyId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el conteo de respuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getIncompleteSurveyResponseCount = async surveyId => {
  try {
    const response = await api.get(
      `/reports/getIncompleteSurveyResponseCount/${surveyId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el conteo de respuestas incompletas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getSurveyResponseStats = async surveyId => {
  try {
    const response = await api.get(
      `/reports/getSurveyResponseStats/${surveyId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el conteo de respuestas incompletas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getQuestionOptionStats = async surveyId => {
  try {
    const response = await api.get(
      `/reports/getQuestionOptionStats/${surveyId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el conteo de respuestas incompletas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getLastCompleteSurveyResponse = async surveyId => {
  try {
    const response = await api.get(
      `/reports/getLastCompleteSurveyResponse/${surveyId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener la última respuesta completada:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
